<template>
    <div class="detail-container">
        <div class="detail-placeholder" v-if="!data">
            <span class="detail-notification-icon">
                <i class="fas fa-external-link-alt"></i>
            </span>
            <span class="detail-notification-text">
                {{ "목록에서 알람을 선택하세요." }}
            </span>
        </div>
        <!-- 2.상세 정보 영역 -->
        <div style="height:90%" v-if="data">
            <div class="detail-header">
                <div class="detail-title">
                    <span class="title">{{ viewTitle }}</span>
                    <span class="badge other"> {{ data.alarm.alarmIdx ?? "-" }} </span>
                    <span class="badge title2"> {{ alarmType }} </span>
                    <span class="badge title1"> {{ severity }} </span>
                </div>
                <span
                    style="display: flex; align-items: center; font-size: 1rem; cursor: pointer"
                    @click="handleClose($event)"
                >
                    <i class="fa fa-times" aria-hidden="true"></i>
                </span>
                <!-- <div class="detail-control" v-if="!isNewMode">
                    <b-form-checkbox switch v-model="isEditMode" size="lg" />
                </div> -->
            </div>
            <div class="detail-content" v-if="data">
                <TableList
                    ref="table-list"
                    :title="'알람 이벤트 목록'"
                    :columns="columns"
                    :rows="detailList"
                    :keyField="'alarmLogIdx'"
                    :transCodes="transCodes"
                    :controls="controls"
                    :useMaxHeight="true"
                    :mode="'edit'"
                    :isPageNation="true"
                    :useFilter="false"
                    :customRowHeight="'99%'"
                    :showAllLabel="false"
                    :totNumber="selectedAlarmEventTot"
                    @button-click="handleListButtonClick"
                    @on-per-page-change="onPerPageChange"
                    @on-page-change="onPageChange"
                    @row-click="handleRowClick"
                    :headerMargin="'0px'"
                    perPageOpt="50"
                />
            </div>
        </div>

        <!-- 3.하단 영역 -->
        <div class="detail-bottom" v-if="data">
            <div class="detail-bottom-info">
                <span>{{ `생성일자: ${data.alarm.regDate ?? "-"}` }}</span>
                <span>{{ `발생일자: ${data.alarm.modDate ?? "-"}` }}</span>
            </div>
            <!-- <div class="detail-bottom-buttons">
                <button type="button" class="btn btn-secondary detail-btn" @click="handleClose($event)">
                    {{ "닫기" }}
                </button>
            </div> -->
        </div>
        <TotalLogModal
            v-if="pointInfo"
            ref="TotalLogModal"
            :pointInfo="pointInfo"
            :alarmDate="alarmDate"
            :alarmDetail="data"
            :eventInfo="eventInfo"
            :type="'Alarm'"
            :routeMgmt="false"
            @hide="hideTotalLogModal"
        />
        <EventLogPopup v-if="eventLogIdx" ref="EventLogModal" :eventLogIdx="eventLogIdx" :readonly="true" />
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import TableList from "@views/component/v2.1/ListDetailView/TableList.vue";
import { mapActions, mapState } from "vuex";
import TotalLogModal from "../../point-management/point-mgmt/modal/TotalLogModal.vue";
import EventLogPopup from "@src/views/sys/system-log/eventLog/EventLogPopup.vue";

// 상수 정의
const EVENT_SOURCE_TYPE = {
    POINT: "Point",
    SYSTEM: "System",
};

const ALARM_STATUS = {
    ACTIVE: "Active",
    ACKED: "Acked",
    RESOLVED: "Resolved",
    DISMISSED: "Dismissed",
};

const HTTP_STATUS = {
    OK: 200,
};

export default {
    components: {
        TableList,
        TotalLogModal,
        EventLogPopup,
    },

    props: {
        title: {
            type: String,
            default: "",
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        selectedAlarmEventTot: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            // 모달 상태 관리
            pointInfo: null,
            alarmDate: null,
            eventIdx: null,
            eventInfo: null,
            eventLogIdx: null,
        };
    },

    computed: {
        ...mapState({
            commonCodes: (state) => state.commonCodes,
        }),

        // 알람 상태 변경 컨트롤 버튼
        controls() {
            return [
                { event: ALARM_STATUS.ACTIVE, label: "활성", class: "btn-primary" },
                { event: ALARM_STATUS.ACKED, label: "인지", class: "btn-info" },
                { event: ALARM_STATUS.RESOLVED, label: "해결", class: "btn-success" },
                { event: ALARM_STATUS.DISMISSED, label: "무시", class: "btn-secondary" },
            ];
        },

        // 코드 변환 설정
        transCodes() {
            return [
                { field: "alarmType", codes: this.commonCodes.alarmType },
                { field: "severity", codes: this.commonCodes.alarmSeverity },
                { field: "status", codes: this.commonCodes.alarmStatus },
                { field: "eventSrcType", codes: this.commonCodes.eventType },
            ];
        },

        // 테이블 컬럼 정의
        columns() {
            const centerClass = { thClass: "text-center", tdClass: "text-center" };

            return [
                {
                    label: this.$t("발생일자"),
                    field: "regDate",
                    type: "text",
                    width: "90px",
                    ...centerClass,
                },
                {
                    label: this.$t("알람유형"),
                    field: "alarmType",
                    type: "text",
                    width: "90px",
                    ...centerClass,
                },
                {
                    label: this.$t("심각도"),
                    field: "severity",
                    type: "text",
                    width: "70px",
                    ...centerClass,
                },
                {
                    label: this.$t("상태"),
                    field: "status",
                    type: "text",
                    width: "60px",
                    ...centerClass,
                },
                {
                    label: this.$t("이벤트 유형"),
                    field: "eventSrcType",
                    type: "text",
                    width: "90px",
                    ...centerClass,
                },
                {
                    label: this.$t("내용"),
                    field: "message",
                    type: "text",
                    ...centerClass,
                },
            ];
        },

        // 이벤트 목록
        detailList() {
            return this.data?.events ?? [];
        },

        // 화면 타이틀
        viewTitle() {
            return this.title;
        },

        // 알람 유형 텍스트
        alarmType() {
            return this.getCodeText(this.commonCodes.alarmType, this.data?.alarm?.alarmType);
        },

        // 심각도 텍스트
        severity() {
            return this.getCodeText(this.commonCodes.alarmSeverity, this.data?.alarm?.severity);
        },

        // 알람 인덱스
        alarmIdx() {
            return this.data?.alarm?.alarmIdx ?? null;
        },
    },

    methods: {
        ...mapActions({
            updateAlarmBadge: "UPDATE_ALARM_BADGE",
        }),

        /**
         * 공통 유틸: 코드 값으로 텍스트 조회
         * @param {Array} codeList - 코드 목록
         * @param {String|Number} value - 조회할 값
         * @returns {String} 코드 텍스트 또는 "-"
         */
        getCodeText(codeList, value) {
            const code = codeList?.find((item) => item.value == value);
            return code?.text ?? "-";
        },

        /**
         * 날짜에서 년월일만 추출
         * @param {String} datetime - 날짜 시간 문자열
         * @returns {String|null} 날짜 부분만 또는 null
         */
        extractDate(datetime) {
            return datetime?.split(" ")[0] ?? null;
        },

        /**
         * TotalLogModal 닫기 및 상태 초기화
         */
        async hideTotalLogModal() {
            await this.$refs.TotalLogModal?.hideModal();
            this.resetModalState();
        },

        /**
         * 모달 관련 상태 초기화
         */
        resetModalState() {
            this.pointInfo = null;
            this.alarmDate = null;
            this.eventInfo = null;
            this.eventLogIdx = null;
        },

        /**
         * 테이블 행 클릭 이벤트 핸들러
         * @param {Object} data - 행 데이터
         */
        async handleRowClick(data) {
            const handlers = {
                [EVENT_SOURCE_TYPE.POINT]: this.handlePointEvent,
                [EVENT_SOURCE_TYPE.SYSTEM]: this.handleSystemEvent,
            };

            const handler = handlers[data.eventSrcType];
            if (handler) {
                await handler.call(this, data);
            }
        },

        /**
         * Point 이벤트 처리
         * @param {Object} data - 이벤트 데이터
         */
        async handlePointEvent(data) {
            this.alarmDate = this.extractDate(data.regDate);
            this.eventIdx = data.eventIdx;
            this.eventInfo = data;

            await this.fetchAndShowPointInfo(this.data.alarm.eventObjIdx);
        },

        /**
         * System 이벤트 처리
         * @param {Object} data - 이벤트 데이터
         */
        async handleSystemEvent(data) {
            this.eventLogIdx = data.eventIdx;

            if (!this.isEmpty(this.eventLogIdx)) {
                this.$nextTick(() => {
                    this.$refs.EventLogModal?.show();
                });
            }
        },

        /**
         * 관제점 정보 조회 및 모달 표시
         * @param {Number} idx - 관제점 인덱스
         */
        async fetchAndShowPointInfo(idx) {
            try {
                await this.getPointInfo(idx);

                if (!this.isEmpty(this.pointInfo)) {
                    this.$nextTick(() => {
                        this.$refs.TotalLogModal?.showModal();
                    });
                }
            } catch (error) {
                console.error("Failed to fetch point info:", error);
            }
        },

        /**
         * 관제점 상세 정보 조회
         * @param {Number} idx - 관제점 인덱스
         */
        async getPointInfo(idx) {
            try {
                const { status, data } = await backEndApi.pointInfo.getPointDetailNew(idx);

                if (status === HTTP_STATUS.OK) {
                    this.pointInfo = data;
                } else {
                    this.alertWarning(data?.message ?? "관제점 정보 조회에 실패했습니다.");
                }
            } catch (error) {
                console.error("Error fetching point info:", error);
                this.alertWarning("관제점 정보를 가져오는 중 오류가 발생했습니다.");
            }
        },

        /**
         * 페이지 변경 이벤트 전달
         * @param {Number} page - 페이지 번호
         */
        onPageChange(page) {
            this.$emit("on-page-change", page);
        },

        /**
         * 페이지당 항목 수 변경 이벤트 전달
         * @param {Number} limit - 항목 수
         */
        onPerPageChange(limit) {
            this.$emit("on-per-page-change", limit);
        },

        /**
         * 상세 화면 닫기
         */
        handleClose() {
            this.$emit("close");
        },

        /**
         * 알람 상태 일괄 변경 처리
         * @param {String} event - 변경할 상태 값
         */
        async handleListButtonClick(event) {
            const checkedRows = this.getCheckedRows();

            if (!this.validateCheckedRows(checkedRows)) {
                return;
            }

            const confirmed = await this.confirmStatusChange();
            if (!confirmed) {
                return;
            }

            await this.updateAlarmStatusBatch(checkedRows, event);
        },

        /**
         * 체크된 행 가져오기
         * @returns {Array} 체크된 행 목록
         */
        getCheckedRows() {
            return this.$refs["table-list"]?.getCheckedRows() ?? [];
        },

        /**
         * 체크된 행 유효성 검증
         * @param {Array} rows - 체크된 행 목록
         * @returns {Boolean} 유효성 여부
         */
        validateCheckedRows(rows) {
            if (this.isEmpty(rows)) {
                this.alertNoti("상태 변경할 알람 이벤트를 선택해주세요.");
                return false;
            }
            return true;
        },

        /**
         * 상태 변경 확인 다이얼로그
         * @returns {Boolean} 확인 여부
         */
        async confirmStatusChange() {
            const result = await this.alertConfirmWarning("알람 이벤트 상태를 변경하시겠습니까?");
            return result?.value ?? false;
        },

        /**
         * 알람 상태 일괄 업데이트
         * @param {Array} items - 업데이트할 항목 목록
         * @param {String} status - 변경할 상태
         */
        async updateAlarmStatusBatch(items, status) {
            const statusName = this.getCodeText(this.commonCodes.alarmStatus, status);
            let successCount = 0;
            let failCount = 0;

            // Promise.all을 사용하여 병렬 처리 (성능 개선)
            const results = await Promise.allSettled(
                items.map((item) =>
                    backEndApi.newAlarm.updateAlarmLogStatus({
                        alarmLogIdx: item.alarmLogIdx,
                        status,
                    })
                )
            );

            results.forEach((result) => {
                if (result.status === "fulfilled" && result.value.status === HTTP_STATUS.OK) {
                    successCount++;
                } else {
                    failCount++;
                }
            });

            // 결과 알림
            if (failCount > 0) {
                this.alertWarning(`${failCount}건의 알람 이벤트 상태 변경에 실패했습니다. (성공: ${successCount}건)`);
            } else {
                await this.alertNoti(`${successCount}건의 알람 이벤트 상태를 ${statusName}(으)로 변경하였습니다.`);
            }

            // 뱃지 업데이트 및 새로고침
            if (successCount > 0) {
                this.updateAlarmBadge(true);
                this.$emit("refresh", this.alarmIdx);
            }
        },
    },
};
</script>

<style scoped>
.detail-container {
    height: 100%;
    width: 100%;
    padding: 1rem 1rem 1rem 1rem;
    border-radius: 10px;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    font-size: 12px;
}
.detail-placeholder {
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.detail-notification-icon {
    padding: 1rem;
    color: #444;
    font-size: 48px;
}

.detail-notification-text {
    font-size: 15px;
    font-weight: bold;
}
.detail-bottom {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* padding-top: 40 px; */
}
.tl-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: hidden;
    flex-grow: 0;
    background-color: #f1f1f1;
    padding: 7px 0px 7px 16px !important;
    margin: 0px !important;
    font-weight: bold;
    border-radius: 6px 6px 0px 0px;
    border: solid #ececec 1px;
    border-bottom: 1px solid #ccc;
}
.btn-group .btn {
    min-width: 30px;
}
.detail-header {
    margin-bottom: 0px !important;
    padding: 8px 16px 8px 16px;
    overflow: hidden;

    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 6px 6px 0px 0px;
    background-color: #f1f1f1;
    border: solid #ececec 1px;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
}
.detail-header .detail-title {
    padding: 0 !important;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.title {
    /* font-size: 14px; */
    font-weight: 600;
    margin-right: 20px;
}
.badge {
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
    min-width: 20px;
    padding: 0px 10px 0px 10px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    /* background-color: #777; */
    line-height: 22px;
    border-radius: 8px;
}

.badge.title1 {
    background-color: #ff6d00;
    color: #fff;
}

.badge.title2 {
    background-color: #546e7a;
    color: #fff;
}

.badge.others {
    background-color: #cfd8dc;
    color: #000;
}
.detail-control {
    margin-bottom: 8px !important;
    display: flex;
    justify-content: flex-end;
}
.detail-content {
    width: 100%;
    height: 100%;
    margin-top: 2px;
    padding: 10px 10px 30px 10px;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
    background-color: white;
    border: solid #ececec 1px;
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */
}
.detail-bottom-info {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 8px 4px 8px;
}
.detail-bottom-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 4px;
}
.detail-btn {
    flex: 1;
    margin: 0px 4px 0px 4px;
}
</style>
